import { render, staticRenderFns } from "./BtnPrint.vue?vue&type=template&id=7283bc50"
import script from "./BtnPrint.vue?vue&type=script&lang=js"
export * from "./BtnPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports